import React, { useId } from 'react';

// The purple flame logo used on the login screen and empty-state placeholders.
const FlameIcon = ({ className = 'w-16 h-16' }) => {
  const gradId = useId();
  return (
    <svg viewBox="0 0 64 64" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="50%" y1="100%" x2="50%" y2="0%">
          <stop offset="0%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#c084fc" />
        </linearGradient>
      </defs>
      <path d="M32 4C28 12 16 20 16 32C16 41.941 23.059 50 32 50C40.941 50 48 41.941 48 32C48 24 44 17 40 12C39 18 36 22 32 24C36 16 36 8 32 4Z" fill={`url(#${gradId})`} />
      <path d="M32 52C26 46 24 40 24 35C24 31 26 28 28 25C28 30 30 33 32 34C34 33 36 30 36 25C38 28 40 31 40 35C40 40 38 46 32 52Z" fill={`url(#${gradId})`} opacity="0.5" />
    </svg>
  );
};

export default FlameIcon;
